<script setup>
import _ from "lodash";

const { data } = await useFetch2("/api/articles");
const summaryList = computed(() => _.take(_.get(data.value, "list", []), 3));
</script>

<template lang="pug">
div(v-if="summaryList.length")
  WebBlockTitle 比赛资讯
  UiFlex.list(
    row,
    mobileCol,
    wrap,
    justify="start",
    items="stretch",
    :gap="false"
  )
    WebNewsSummaryCard.item(
      v-for="item in summaryList",
      :key="item.id",
      v-bind="item"
    )
</template>
<style lang="scss" scoped>
.list {
  gap: 10px;
}
.item {
  width: calc((100% - 10px * 2) / 3);
  flex: 0 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>